import React from 'react';

interface ProgressBarProps {
  progress: number;
  showPercentage?: boolean;
  className?: string;
  height?: 'sm' | 'md' | 'lg';
  color?: 'default' | 'success' | 'warning' | 'error';
}

export function ProgressBar({ 
  progress, 
  showPercentage = false, 
  className = '',
  height = 'md',
  color = 'default'
}: ProgressBarProps) {
  const clampedProgress = Math.max(0, Math.min(100, progress));
  
  const heightClasses = {
    sm: 'h-2',
    md: 'h-3',
    lg: 'h-4'
  };
  
  const colorClasses = {
    default: 'bg-neutral-200',
    success: 'bg-green-200',
    warning: 'bg-yellow-200',
    error: 'bg-red-200'
  };
  
  const fillColorClasses = {
    default: 'bg-neutral-600',
    success: 'bg-green-600',
    warning: 'bg-yellow-600',
    error: 'bg-red-600'
  };
  
  const baseClasses = 'w-full rounded-full overflow-hidden';
  const classes = `${baseClasses} ${heightClasses[height]} ${colorClasses[color]} ${className}`;
  
  return (
    <div className={classes}>
      <div 
        className={`h-full transition-all duration-500 ease-out ${fillColorClasses[color]}`}
        style={{ width: `${clampedProgress}%` }}
        role="progressbar"
        aria-valuenow={clampedProgress}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`Progress: ${clampedProgress}%`}
      />
      {showPercentage && (
        <div className="mt-2 text-right">
          <span className="text-sm font-medium text-neutral-600">
            {clampedProgress.toFixed(0)}%
          </span>
        </div>
      )}
    </div>
  );
}